<template>
  <div class="table-container">
    <table class="table is-fullwidth is-narrow is-hoverable">
      <thead>
        <tr class="is-unselectable">
          <th @click="$emit('order', 'group.name')">Name</th>
          <th @click="$emit('order', 'computers.length')">
            Computers
          </th>
        </tr>
      </thead>
      <TableEffect>
        <tr v-for="groupItem of items" :key="groupItem.group.uid">
          <td>
            <div @contextmenu.prevent="$emit('menu', { e: $event, groupItem })">
              <router-link
                v-if="!groupItem.group.edit"
                :to="
                  `/domains/${$route.params.domainUID}/groups/${groupItem.group.uid}/packages`
                "
              >
                <span class="icon">
                  <i class="mdi mdi-monitor-multiple"></i>
                </span>
                <span>{{ groupItem.group.name }}</span>
              </router-link>
              <EditSingleField
                v-if="groupItem.group.edit"
                :text="groupItem.group.name"
                validation="required"
                type="text"
                name="name"
                @save="$emit('save', { groupItem: groupItem, text: $event })"
                @cancel="$emit('cancel', groupItem)"
                :isLoading="groupItem.group.saving"
              ></EditSingleField>
            </div>
          </td>
          <td>{{ groupItem.computers.length }}</td>
        </tr>
      </TableEffect>
    </table>
  </div>
</template>

<script>
export default {
  props: { items: Array },
  components: {
    TableEffect: () => import("@/components/singles/TableEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
};
</script>
